import type { IconData } from '@stacksjs/iconify-core'

export const flightTakeoff: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 464h480v32H16zm439.688-311.836c-23.388-6.515-48.252-6.053-70.008 1.3l-.894.3l-65.1 30.94l-189.981-75.528a47.72 47.72 0 0 0-49.771 8.862L54.5 140.836a24 24 0 0 0 2.145 37.452l117.767 83.458l-45.173 23.663l-35.775-32.687a48.07 48.07 0 0 0-51.47-8.6l-19.455 8.435a24 24 0 0 0-11.642 33.3l72.821 136.827L480.3 227.21c23.746-11.177 26.641-29.045 21.419-42.059c-5.788-14.428-22.568-26.451-46.031-32.987m10.9 46.133l-.149.07l-369.045 181.9l-54.176-101.8l11.5-4.987a16.02 16.02 0 0 1 17.157 2.867l52.336 47.819l111.329-58.318L83.322 157.974l17.971-16.108a15.91 15.91 0 0 1 16.59-2.954l202.943 80.681l75.95-36.095c15.456-5.009 33.863-5.165 50.662-.413c13.834 3.914 21.182 9.6 23.672 12.582a24.2 24.2 0 0 1-4.52 2.633Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default flightTakeoff
